import { render } from "./SubjectsPicker.vue?vue&type=template&id=1b3e2c1c"
import script from "./SubjectsPicker.vue?vue&type=script&lang=js"
export * from "./SubjectsPicker.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__